<template>
  <div class="go-in" id="hornor">
    <div
      class="organizational"
      :style="`height:${pageLoading ? '3rem' : 'auto'};`"
      v-loading="pageLoading"
    >
      <div style="box-sizing: border-box">
        <TitleTips
          :routerList="routerList"
          routeType="/gywm/honoraryQualification"
          title="荣誉资质"
        />
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          font-size: 0.16rem;
        "
      >
        <el-row style="margin-bottom: 0.35rem">
          <el-col :span="24">
            <el-radio-group
              v-model="formData.groupType"
              @change="changeType"
              size="small"
            >
              <el-radio-button label="113">荣誉</el-radio-button>
              <el-radio-button label="109">资质</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6" v-for="(item, index) in pageData" :key="index">
            <div style="margin-bottom: 10px; text-align: center">
              <div>
                <img
                  :src="getUrl(item.url)"
                  alt="home"
                  style="height: 2.5rem; width: 100%;overflow: hidden;"
                />

                <div style="text-align: center; font-size: 16px;height:23px">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div
          style="margin: 0.2rem 0rem; font-size: 0.16rem; align-self: center"
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from '../components/TitleTips.vue';
import http from '../utils/http';
import getFileUrl from '../utils/urlHelp';
export default {
  components: {
    TitleTips
  },
  name: 'honoraryQualification',
  data() {
    return {
      pageLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      formData: {
        groupType: '113'
      },
      pageData: [],
      routerList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getUrl(str) {
      const res = getFileUrl(str);
      return res;
    },
    getData() {
      this.pageLoading = true;
      http
        .post('/reception/about/getAllUs', {
          ...this.formData,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          title: ''
        })
        .then(res => {
          this.pageData = res.rows;
          this.total = res.total;
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    changeType() {
      this.pageNum = 0;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    }
  },
  mounted() {
    this.routerList = this.$route.matched;

    // window.onkeydown = window.onkeyup = window.onkeypress = function (event) {

    //     // 判断是否按下F12，F12键码为123

    //     if (event.keyCode == 123) {

    //     event.preventDefault(); // 阻止默认事件行为

    //     window.event.returnValue = false;

    //     }
    // }
    // this.$refs.hornor.oncopy = function(){return false};
  },

  watch: {
    // $route: {
    //   handler: function(val, oldVal){
    //     if(val!=oldVal){
    //     }
    //   },
    //   // 深度观察监听
    //   deep: true
    // }
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .organizational {
    width: 100%;
    box-sizing: border-box;
    padding: 0rem 1rem 0rem 1rem;
  }
}
.show-product {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: flex-end;
  .item-name {
    text-align: center;
    font-size: 0.2rem;
  }
}
</style>
